(() => {
  const config = document.querySelector('[data-ah-gift-config]');
  if (!config) return;
  const bookId = Number(config.dataset.bookId);
  const giftId = Number(config.dataset.giftId);
  const root = config.dataset.root;
  let pending;
  function syncGift() {
    if (pending) return pending;
    pending = (async () => {
      const response = await fetch(root + 'cart.js');
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      const wanted = cart.items.some(item => item.variant_id === bookId);
      const gifts = cart.items.filter(item => item.variant_id === giftId);
      const quantity = gifts.reduce((sum, item) => sum + item.quantity, 0);
      if ((wanted && quantity === 1) || (!wanted && quantity === 0)) return false;
      let result;
      if (wanted && !gifts.length) {
        result = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({items: [{id: giftId, quantity: 1}]})
        });
      } else {
        const updates = {};
        gifts.forEach((item, index) => { updates[item.key] = wanted && index === 0 ? 1 : 0; });
        result = await fetch(root + 'cart/update.js', {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({updates})
        });
      }
      if (!result.ok) throw new Error('Gift could not be prepared');
      return true;
    })().finally(() => { pending = null; });
    return pending;
  }
  async function checkout(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      await syncGift();
      location.assign(root + 'checkout');
    } catch (error) {
      alert('We could not prepare your free guide. Please try again.');
    }
  }
  document.addEventListener('click', event => {
    if (event.target.closest('button[name="checkout"],input[name="checkout"],a[href$="/checkout"]')) checkout(event);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter && event.submitter.name === 'checkout') checkout(event);
  }, true);
  if (location.pathname === root + 'cart' || location.pathname === root + 'cart/') {
    syncGift().then(changed => { if (changed) location.reload(); }).catch(() => {});
  }
})();
